export type SelectAllState = boolean | "indeterminate";

export const getSelectAllState = <TId extends string | number>(
  availableIds: readonly TId[],
  selectedIds: readonly TId[],
): SelectAllState => {
  if (availableIds.length === 0) return false;

  const selectedIdSet = new Set(selectedIds);
  const hasSelectedId = availableIds.some((id) => selectedIdSet.has(id));

  if (!hasSelectedId) return false;

  return availableIds.every((id) => selectedIdSet.has(id))
    ? true
    : "indeterminate";
};
